import { user_logout, user_refresh, user_login, user_quickLogin } from '@/api/login'
import router from '@/router'
import Cookies from 'js-cookie'
import store from '@/store'
import { HttpCode, AuthEnum } from '@/utils/setting'
import {
  getToken,
  setToken,
  getRefreshToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
  setWatchInterval,
  getWatchInterval,
  removeWatchInterval,
  getRefreshTime,
  setRefreshTime,
  removeRefreshTime
} from '@/utils/auth'
import { isEmtry } from '@/utils'

const state = {
  userinfo: {},
  isLogin: null,
  watchTokenTimer: null,
  watchInterval: 1000 * 60 * 10, // 10分钟
  crrInterval: 0 // 当前间隔
}

const mutations = {
  setUserinfo(state, info) {
    state.userinfo = info
    state.isLogin = Boolean(info.token)
    localStorage.setItem('userinfo', JSON.stringify(info))
  }
}

const actions = {
  // 账号登录
  async doAccountLogin({ state, commit }, params) {
    const { code, data } = await user_login(params)
    if (code === HttpCode.SUCCESS) {
      commit('setUserinfo', data)
      setToken(data.token)
      setRefreshToken(data.refreshToken)
    }
  },
  // 手机登录
  async doPhoneLogin({ state, commit }, params) {
    const { code, data } = await user_quickLogin(params)
    if (code === HttpCode.SUCCESS) {
      commit('setUserinfo', data)
      setToken(data.token)
      setRefreshToken(data.refreshToken)
    }
  },

  // 退出登录
  async doLogout(state, path) {
    const res = await user_logout()
    if (res.code === HttpCode.SUCCESS) {
      removeToken()
      removeRefreshToken()
      removeWatchInterval()
      removeRefreshTime()
      clearInterval(state.watchTokenTimer)
      localStorage.removeItem('userinfo')
      path && router.push(path)
      location.reload()
    }
  },
  // 刷新token
  async doRefreshToken({ state, dispatch }) {
    const token = getRefreshToken()
    if (!token) {
      dispatch('doLogout', '/')
      return
    }
    const { code, data } = await user_refresh({ refreshToken: token })
    if (code === HttpCode.SUCCESS) {
      setToken(data.token)
      setRefreshToken(data.refreshToken)
      state.crrInterval = 0
      setWatchInterval(0)
      setRefreshTime(new Date().getTime(), state.watchInterval)
    }
  },
  // 开启轮询token
  startWatchToken({ state, dispatch }) {
    if (!state.isLogin) return
    setWatchInterval(state.crrInterval)
    state.crrInterval = getWatchInterval()
    clearInterval(state.watchTokenTimer)
    state.watchTokenTimer = setInterval(async() => {
      state.crrInterval += 1000
      if (state.crrInterval >= state.watchInterval) {
        console.log('刷新token成功（轮询触发）')
        dispatch('doRefreshToken')
      }
    }, 1000)
  },
  // 是否需要刷新token
  needRefreshToken({ state, dispatch }) {
    if (!state.isLogin) return
    if (isEmtry(getRefreshTime())) {
      console.log('刷新token成功（过期触发）')
      dispatch('doRefreshToken')
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
